
export enum MyCourseActionTypes {
    FETCH_REQUEST = '@@MyCourse/FETCH_REQUEST',
    FETCH_SUCCESS = '@@MyCourse/FETCH_SUCCESS',
    FETCH_ERROR = '@@MyCourse/FETCH_ERROR',

    SELECT = '@@MyCourse/SELECT',
    SELECTED = '@@MyCourse/SELECTED',
    CLEAR_SELECTED = '@@MyCourse/CLEAR_SELECTED',
    
    ADD = '@@MyCourse/CREATE',
    ADD_SUCCESS = '@@MyCourse/ADD_SUCCESS',
    ADD_ERROR = '@@MyCourse/ADD_ERROR',
    ADD_CLEAR = '@@MyCourse/ADD_CLEAR',

    EDIT = '@@MyCourse/EDIT',
    EDIT_SUCCESS = '@@MyCourse/EDIT_SUCCESS',
    EDIT_ERROR = '@@MyCourse/EDIT_ERROR',
    
    ASKTRAINER = '@@MyCourse/ASKTRAINER',
    ASKTRAINER_SUCCESS = '@@MyCourse/ASKTRAINER_SUCCESS',
    ASKTRAINER_ERROR = '@@MyCourse/ASKTRAINER_ERROR',
    
    NOTIFIED = '@@MyCourse/NOTIFIED',
}

export interface MyCourseUIState {
    readonly loading: boolean
    readonly selected?: number
    readonly errors?: string
    readonly totDoc?: number
    readonly adding: boolean
    readonly addState?: number
    readonly notificed: boolean
}